import { useState } from "react";
import { FieldError } from "react-hook-form";
import { FootLength, FootWidth } from "../../api/schemas";
import { defaultWidthAndSizeFormValues } from "../../consts/form";
import { WidthAndSizeFormValues } from "../../types/form";
import { Path } from "../../types/route";
import { SelectWidthAndSize } from "./SelectWidthAndSize";

interface SelectWidthAndSizeContainerProps {
  footLengths: FootLength[];
  footWidths: FootWidth[];
  path: Path;
  setPath: (path: Path) => void;
  onChange: (widthAndSize: WidthAndSizeFormValues) => void;
  value: WidthAndSizeFormValues;
  isDirty: boolean;
  error: FieldError | undefined;
}

export function SelectWidthAndSizeContainer({
  footLengths,
  footWidths,
  path,
  setPath,
  onChange,
  value,
  isDirty,
  error,
}: SelectWidthAndSizeContainerProps) {
  const [tmpValue, setTmpValue] = useState<WidthAndSizeFormValues>(
    defaultWidthAndSizeFormValues,
  );
  const [prevPath, setPrevPath] = useState(path);

  if (path !== prevPath) {
    setPrevPath(path);
    setTmpValue(value);
  }

  return (
    <SelectWidthAndSize
      footLengths={footLengths}
      footWidths={footWidths}
      path={path}
      setPath={setPath}
      value={value}
      tmpValue={tmpValue}
      onChange={onChange}
      isNextButtonDisabled={!isDirty || error !== undefined}
    />
  );
}
